var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29289 3.29289C3.65338 2.93241 4.22061 2.90468 4.6129 3.2097L4.70711 3.29289L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3466 13.0676 11.7794 13.0953 11.3871 12.7903L11.2929 12.7071L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z",
    fill: "#393D50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7071 3.29289C12.3466 2.93241 11.7794 2.90468 11.3871 3.2097L11.2929 3.29289L3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071C3.65338 13.0676 4.22061 13.0953 4.6129 12.7903L4.70711 12.7071L12.7071 4.70711C13.0976 4.31658 13.0976 3.68342 12.7071 3.29289Z",
    fill: "#393D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close-black.751b53d18a74d17dc59e9c61ca1af9d1.svg";
export { ForwardRef as ReactComponent };